import { getDistributionButtonStyle } from '../utils/getDistributionButtonStyle';

type ButtonSubmitProps = {
  condition: boolean;
  label: string;
  onSubmit: () => Promise<void>;
  loading: boolean | void;
};

export const ButtonSubmit = ({
  condition,
  label,
  onSubmit,
  loading
}: ButtonSubmitProps) => {
  return (
    <button
      disabled={getDistributionButtonStyle(condition).disabled}
      className={`tw-mt-[10px] tw-w-full tw-text-[#FFFFFF] tw-py-[13px] tw-rounded-[134px] ${
        getDistributionButtonStyle(condition).background
      } ${getDistributionButtonStyle(condition).pointer}`}
      onClick={() => {
        loading === false && onSubmit();
      }}
    >
      {loading === true ? 'Carregando...' : label}
    </button>
  );
};
